<div class="main-container">
    <div class="middle-container">
        <div class="title">Maintenance en cours...</div>
        <div class="subtitle">Paul Mazeau</div>
        <div class="contact">contact@paul-mazeau.fr</div>
    </div>
</div>
